<ion-card class="card-wallet ion-no-margin" [class.flipped]="Data?.ShowBack"
    [class.disabled]="Data==null||!Data?.Enabled"
    [style.background-image]="Data?.Id ? Data?.ShowBack ? 'url('+Data?.Image?.Back+')': 'url('+Data?.Image?.Front+')':''">

    <ion-card-content>

        <ng-container *ngIf="Data?.Id">

            <ion-grid class="front">

                <ion-row class="top">
                    <p *ngIf="OnlyVirtual">Virtual</p>
                    <ion-icon *ngIf="!OnlyVirtual" src="assets/images/card-contactless.svg"></ion-icon>
                </ion-row>

                <ion-row>
                    <ion-col>{{Data?.Number}}</ion-col>
                </ion-row>

                <ion-row>
                    <ion-col>{{Data?.Owner}}</ion-col>
                    <ion-col class="validity">{{Data?.ValidationDate ? (Data?.ValidationDate|date:'MM/YY') :
                        '--/--'}}</ion-col>
                </ion-row>

            </ion-grid>

        </ng-container>

        <ng-container *ngIf="!Data?.Id || !Data">

            <ion-grid class="new-card">
                <ion-row>
                    <ion-col style="display: flex;" class="ion-justify-content-center">

                        <ion-icon style="font-size:40px" name="alert-circle-outline"></ion-icon>

                    </ion-col>
                </ion-row>

            </ion-grid>
        </ng-container>

    </ion-card-content>

</ion-card>